import React from 'react';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";

import * as ResourceApi from "api/resources";
import {createButtonSectionFactoryWithAdditionalArgs, createButtonSectionFactory} from "hoc/CreateButtonSection";

export default {
    key: "breakSiteSection",
    props: {
        // getInnerHeader: () => "Content Network"
        getInnerHeader: (props) => {
            // props is the step
            console.log(`Content Network getInnerHeader`, props)
            if (props.currentResource.siteMetas && props.currentResource.siteMetas.length) {
                return "Content Network"
            } else {
                return "⚠️ Content Network"
            }
        }
    },
    fields: [
        {
            type: 'hardcodedText',
            key: "content-network-intro",
            props: {
              text: 'This section allows you to control which sites this break will be published to and how the content is categorized on each site.',
            }
        },

        {
            name: 'siteMetas',
            resource: true,
            subSection: true,
            collection: true,
            sectionWrapper: IndexedSubSectionWrapper,
            deletable: true,
            canDelete: (formProxy) => {
                // console.log(`formProxy.currentResource`, formProxy.currentResource)
                return true;
            },
            // sortable: true,
            // sortableName: "sitesOrder",
            // toggleSortLabelKey: 'editbreak.steps.receipt_verification.instruction.reorder_toggle',
            resourceType: ResourceApi.Types.BreakSiteMeta,

            props: {
                headerKey: 'editbreak.steps.receipt.instruction.header',
                getCustomSectionHeader: (breakSite, sectionIndex) => {
                    return   "Site " + (sectionIndex + 1) + ((breakSite.label) ? ": " + breakSite.label : "");
                }
            },

            footerContent: createButtonSectionFactoryWithAdditionalArgs({
                someParam: "site"
            }, ResourceApi.Types.BreakSiteMeta),

            fields: [
                {
                //   type: 'site',
                    type: 'siteDropdown',
                  name: 'siteId',
                  props: {
                    labelKey: 'Site',
                  }
                },
                {
                    name: 'categories',
                    type: 'breakSiteCategory',
        
                    props: {
                        labelKey: 'Category',
                    }
                },
                {
                    name: 'tags',
                    type: 'breakSiteTagEditor',
                    required: false,
                    props: {
                        labelKey: 'Tags',
                    }
                },
            ]        
        },
    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/breaksSiteSection.js